import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import { useDispatch, useSelector } from "react-redux";
import { handleDisableFilter } from "~/Pages/Process/actions/attachmentsSlice";
import SearchFIles from "./SearchFIles";
import FolderListSection from "~/components/folder-list-section/FolderListSection";
import RecentDocuments from "./RecentDocuments";

const EntityDocuments = () => {
  const { id } = useParams();
  const {
    handleClickService,
    states,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
  } = useFileDocuments({ id });

  const dispatch = useDispatch();
  const { blobFilterStates } = useSelector((state) => state.attachments);
  useEffect(() => {
    dispatch(handleDisableFilter(false));
  }, []);
  return (
    <div className="folders-container">
      <FolderListSection
        folders={states?.folders}
        loading={states.loading}
        isFilterApplied={!!blobFilterStates?.selectedItems?.length}
        onFolderClick={handleClickService}
        hideSkeletonOnFilter={false}
        containerClassName="folders-container"
        showEmptyState={true}
        emptyMessage="No files here yet"
        filterContent={
          <SearchFIles
            fileName={fileName}
            setFileName={setFileName}
            additionaltag={{ entity: [states?.entity_detail?.name] }}
            states={states}
            first={first}
            rows={rows}
            onPageChange={onPageChange}
            isRootFolder={true}
          />
        }
      >
        <RecentDocuments entityId={id} />
      </FolderListSection>
    </div>
  );
};

export default EntityDocuments;
